export default __webpack_public_path__ + "static/media/man-listing-his-house-for-sale.11ac9ca0.svg";